module.exports = __webpack_public_path__ + "static/thing-explainer-371ff450807bce4aa832805949a9dbb6.jpg";